import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip } from "@mui/material";
import { MdLocationPin, MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";
// import Custom_Paingation from "../../core/BaseComponents/Custom_Paingation";
import { ScrollToTop, getChainIdLS, isValidRole } from "../../../utils/utils";
import { useSelector } from "react-redux";
    
function CityConfiguration() {
  const [roomList, setRoomList] = useState([]);
  const [confirmDeleteRoom, setConfirmDeleteRoom] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deleteRoomPopUp, setDeleteRoomPopUp] = useState(false);
  const [editRoom, setEditRoom] = useState(false);
  const [editRoomUpdate, setEditRoomUpdate] = useState(false);
  const [createRoomSuccessMsg, setCreateRoomSuccessMsg] = useState('');
  const [editRoomSid, setEditRoomSid] = useState("");
  // const recordsPerPage = 10;
  let userRoleCode = JSON.parse(localStorage.getItem("userDetails"))?.roles[0]?.roleCode;
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    // setValue
  } = useForm({
    mode: 'onChange',
  });

  const { chainId } = useSelector((state) => state.chainIdReducer);
  let validPermissionClassName = isValidRole("CITY_CONFIGURATION_MODIFY")
    ? ""
    : "btn-disable-permission";

  // const [selectedPage, setSelectedPage] = useState(1);
  // const [totalPageCount, setTotalPageCount] = useState(1);
  // const [paginationError, setPaginationError] = useState("")
  // const [inputPageValue, setInputPageValue] = useState(1)

  const onSubmit = (data) => {
    let method = "POST";
    let url = "/hotelCityInfo";

    if (editRoomUpdate) {
      method = "PUT"
      url = `/hotelCityInfo?id=${editRoomSid?.id}`
    }

    callAPI(url, method, data, {chainId: getChainIdLS()})
      .then(function (response) {
        reset({
          city: '',
          latitude: '',
          longitude: '',
        });
        setCreateRoomSuccessMsg(response?.message);
        roomListApi();
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const isRoomDeletedRef = useRef({
    isRoomDeletedModalData: null,
    userConformationModalData: null,
  });

  const deleteRoomPopUpHandler = (row) => {
    setDeleteRoomPopUp(true);
    const newModalRefData = {
      isRoomDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isRoomDeletedRef.current = newModalRefData;
  }

  const deleteRoomHandler = () => {
    setConfirmValidate(true);
    if (confirmDeleteRoom === "") {
      return
    }

    if (confirmDeleteRoom === `Delete City ${isRoomDeletedRef.current?.isRoomDeletedModalData.row.city}`) {
      setConfirmValidate(false)
      const { row } = isRoomDeletedRef.current?.isRoomDeletedModalData;
      callAPI(`/hotelCityInfo?id=${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isRoomDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isRoomDeletedRef.current = newModalRefData;
          roomListApi();
        })
        .catch((error) => {
          console.warn(error)
        });
    }
    reset({
      city: '',
      latitude: '',
      longitude: '',
    });
  }

  const renderActionIcon = (row) => {
    return (
      isValidRole("CITY_CONFIGURATION_MODIFY")?<>
        <Tooltip title="Edit" arrow>
          <MdModeEditOutline
            className="edit-icon-enable"
            onClick={() => { setEditRoom(true); setEditRoomSid(row) }}
          />
        </Tooltip>
        <Tooltip title="Delete" className="cursor-pointer" arrow>
          <DeleteIcon
            className="delete-icon-enable"
            onClick={() => {
              deleteRoomPopUpHandler(row);
            }}
          />
        </Tooltip>
      </>:
          <>
            <Tooltip title="Don't have permission to edit" arrow>
              <span><MdModeEditOutline className="edit-icon-disable" /></span>
            </Tooltip>
            <Tooltip title="Don't have permission to delete" arrow>
              <DeleteIcon className="delete-icon-disable" />
            </Tooltip>
          </>
    );
  };

  const columns = [
    { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "city", headerName: "City", flex: 1 },
    { field: "latitude", headerName: "Latitude", flex: 1 },
    { field: "longitude", headerName: "Longitude", flex: 1 },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  const roomListApi = () => {
    const apiPath = `/hotelCityInfo_All`;
    callAPI(apiPath, "GET", {}, { chainId: getChainIdLS() })
      .then((response) => {
        setRoomList(response)
        // setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
        // setPaginationError("")
      })
      .catch((err) => console.warn(err.message));
  };

  useEffect(() => {
    roomListApi();
    cancelRoomHandler()
  // }, [selectedPage, chainId]);
}, [chainId]);


  const popupCloseHandler = () => {
    setDeleteRoomPopUp(false);
  };

  useEffect(() => {
    if (editRoom) {
      getRoomListSidHandler();
      setEditRoom(false);
    }
    ScrollToTop();
  }, [editRoom, chainId]);

  const getRoomListSidHandler = () => {
    callAPI(`/hotelCityInfo?id=${editRoomSid?.id}`, "GET", {}, { chainId: getChainIdLS() })
      .then(function (response) {
        const payload = {
          city: response?.city,
          latitude: response.latitude,
          longitude: response?.longitude,
        };
        reset(payload);
        setEditRoomUpdate(true);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const resetLayoutHandler = () => {
    reset();
  }

  const cancelRoomHandler = () => {
    reset({
      city: '',
      latitude: '',
      longitude: '',
    });
    setEditRoomUpdate(false);
    setEditRoomSid('');
    setEditRoom(false);
  }

  //Pagination Handle changer
  // const onPageChange = (event, value) => {
  //   setInputPageValue(value)
  //   setPaginationError("")
  //   setSelectedPage(value);
  // };

  return (
    <div className='row config-hotel'>
      <div className='col-12 left-column'>
        <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
          <div className="row">
            <div className="left-column-header">
              <p>{editRoomUpdate ? 'Edit City Details' : "Configuration New City"}</p>
            </div>
            <div className="form-group-hotel col-4">
            <div className={`floating-label`}>
                  <MdLocationPin className="new-hotel-icons" />
                  <input
                    id="city"
                    // disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                    placeholder=""
                    {...register("city", {
                      required: "Please Enter City",
                    })}
                  />
                  <label htmlFor="city">Enter City</label>
                </div>
                {errors.city && (
                  <small className="required">{errors.city.message}</small>
                )}
            </div>
            <div className="col-4 form-group-hotel">
            <div className={`floating-label`}>
                      <MdLocationPin className="new-hotel-icons" />
                      <input
                        id="latitude"
                        // disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                        placeholder=""
                        {...register("latitude", {
                          required: "Please Enter Latitude",
                          pattern: {
                            value: /^-?[0-9]+(\.[0-9]*)?$/,
                            message: "Only numbers and dots are allowed"
                          }
                        })}
                      />
                      <label htmlFor="latitude">Enter Latitude</label>
                    </div>
                    {errors.latitude && (
                      <small className="required">{errors.latitude.message}</small>
                    )}
            </div>
            <div className="col-4 form-group-hotel">
            <div className={`floating-label`}>
                      <MdLocationPin className="new-hotel-icons" />
                      <input
                        id="longitude"
                        // disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                        placeholder=""
                        {...register("longitude", {
                          required: "Please Enter Longitude",
                          pattern: {
                            value: /^-?[0-9]+(\.[0-9]*)?$/,
                            message: "Only numbers and dots are allowed"
                          }
                        })}
                      />
                      <label htmlFor="longitude">Enter Longitude</label>
                    </div>
                    {errors.longitude && (
                      <small className="required">{errors.longitude.message}</small>
                    )}
            </div>
            <div className="col-12 text-end">
              <div>
                <button type="button" className="clear-btn me-2" onClick={cancelRoomHandler}>{editRoomUpdate ? "Cancel" : "Clear All"}</button>
                {editRoomUpdate && <>
                  <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                </>}
                <button type="submit" className={`create-btn ${validPermissionClassName} `}>{editRoomUpdate ? "Update" : "Create"}</button>
              </div>
            </div>
          </div>
        </form>
        <div className="hotel-list">
          <p><b>City Configuration List</b></p>
          <TableWrapper
            data={roomList}
            columns={columns}
            module="room-config"
            noPagination={true}
          />
          {/* <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          /> */}
        </div>
      </div>
      <BasicModal
        popupOpen={deleteRoomPopUp}
        bodyMessage={<>
          <img src={deleteImg} alt="approve" className="w-40px" />
          <div className="delete-hotel mb-3">{isRoomDeletedRef.current?.isRoomDeletedModalData ?
            <div className="confirm-delete-hotel">
              <p>Do you really want to Delete City "<b>{isRoomDeletedRef.current?.isRoomDeletedModalData.row.city}</b>" ?</p>
              <p className="warning"><IoMdWarning /> Warning</p>
              <p>City "{isRoomDeletedRef.current?.isRoomDeletedModalData.row.city}" will be permanently deleted <br />
                Deleting the specified Room can't be undone.
              </p>
              <p className="mt-3">To confirm deletion, type "Delete City {isRoomDeletedRef.current?.isRoomDeletedModalData.row.city}"</p>
              <div className="form-group-hotel mt-3">
                <div className="floating-label">
                  <input
                    id="deleteHotel"
                    placeholder=''
                    onChange={(e) => setConfirmDeleteRoom(e.target.value)}
                  />
                  <label htmlFor="address">Delete City</label>
                </div>
                {(confirmDeleteRoom === "" && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete City {isRoomDeletedRef.current?.isRoomDeletedModalData.row.city}</small></p>
                ) : (confirmDeleteRoom !== `Delete City ${isRoomDeletedRef.current?.isRoomDeletedModalData.row.city}` && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete City {isRoomDeletedRef.current?.isRoomDeletedModalData.row.city}</small></p>
                ) : ""
                }
              </div>
            </div> :
            isRoomDeletedRef.current?.userConformationModalData?.successMessage}</div>
        </>
        }
        footer={
          isRoomDeletedRef.current?.isRoomDeletedModalData ?
            {
              primaryButton: {
                buttonName: "Cancel",
                action: popupCloseHandler
              }
              ,
              secondaryButton: {
                buttonName: "Delete",
                action: deleteRoomHandler
              }
            } : {
              secondaryButton: {
                buttonName: "OK",
                action: popupCloseHandler
              }
            }
        }
      />

      <BasicModal
        popupOpen={createRoomSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createRoomSuccessMsg}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreateRoomSuccessMsg(''); setEditRoomUpdate(false); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
      
    </div>
  )
}

export default CityConfiguration;